import { render, staticRenderFns } from "./notice-board.vue?vue&type=template&id=18b50522&scoped=true"
import script from "./notice-board.vue?vue&type=script&lang=ts"
export * from "./notice-board.vue?vue&type=script&lang=ts"
import style0 from "./notice-board.vue?vue&type=style&index=0&id=18b50522&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b50522",
  null
  
)

export default component.exports